import { Reveal, SectionHead } from "./Reveal";

const BENEFITS = [
    {
        title: "Zabawa jako proces edukacyjny",
        text: "Bezstresowa gra zamieniona w wartościową naukę, nie tylko przerywnik.",
    },
    {
        title: "Wszystkie zmysły i logika",
        text: "Gry angażujące u dzieci ruch, emocje i logiczne myślenie.",
    },
    {
        title: "Współpraca i komunikacja",
        text: "Uczniowie uczą się rozwiązywać problemy i pracować w grupie.",
    },
    {
        title: "Znane zabawy w nowej roli",
        text: "Jak przekształcić proste gry w rozwijające myślenie i język.",
    },
    {
        title: "Mądre gadżety",
        text: "Rekwizyty, które trzymają uwagę od pierwszej do ostatniej minuty.",
    },
    {
        title: "Ład i dobra atmosfera",
        text: "Zarządzanie emocjami i dynamiką grupy bez utraty kontroli.",
    },
];

export default function Benefits() {
    return (
        <section className="relative py-20 sm:py-28 px-4 sm:px-8" data-testid="benefits-section">
            <div className="max-w-7xl mx-auto">
                <SectionHead
                    index="01"
                    label="Co zabierzesz z webinaru"
                    title="Czego dowiesz się podczas webinaru?"
                    lead="Będzie praktycznie i inspirująco. Wyjdziesz z gotowym bankiem gier i pomysłów do wdrożenia od razu."
                />
                <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
                    {BENEFITS.map((b, i) => (
                        <Reveal key={b.title} delay={(i % 3) * 0.1}>
                            <article
                                data-testid={`benefit-card-${i + 1}`}
                                className="group relative h-full rounded-3xl bg-white border border-brand-tint2 p-7 shadow-[0_14px_35px_-22px_rgba(194,24,91,0.35)] transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1.5 hover:border-brand hover:shadow-[0_24px_50px_-22px_rgba(194,24,91,0.5)]"
                            >
                                <span className="font-mono text-sm font-bold text-brand/60 group-hover:text-brand transition-colors duration-300">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                <h3 className="mt-4 text-lg sm:text-xl font-extrabold leading-snug text-brand-ink">
                                    {b.title}
                                </h3>
                                <p className="mt-3 text-sm sm:text-base leading-relaxed text-brand-gray">{b.text}</p>
                            </article>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
